import PropTypes from 'prop-types';
// @mui
import { Badge, Box, ButtonBase, Chip, Stack, Tooltip, Typography } from '@mui/material';
// hooks
import useLocales from '../../hooks/useLocales';
import useModals from '../../hooks/useModals';
import useWhatsNew from '../../hooks/useWhatsNew';
// utils
import { WHATS_NEW_MODAL } from '../../utils/const';

// ----------------------------------------------------------------------

WhatsNewVersionButton.propTypes = {
  isCollapse: PropTypes.bool,
};

// Version at the bottom of the menu: opens "What's new"; chip with a green dot while unseen
export default function WhatsNewVersionButton({ isCollapse }) {
  const { translate } = useLocales();
  const { showModal } = useModals();
  const { latest, hasUnseen, currentVersion } = useWhatsNew();

  if (!currentVersion) return null;

  const open = () => showModal(WHATS_NEW_MODAL, { version: latest?.version });
  const dot = <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: 'primary.main' }} />;

  if (isCollapse) {
    return (
      <Tooltip title={translate('whatsNew')} placement="right">
        <ButtonBase onClick={open} sx={{ mx: 'auto', mb: 1, px: 1, py: 0.5, borderRadius: 1 }}>
          <Badge color="primary" variant="dot" invisible={!hasUnseen}>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {`v${currentVersion}`}
            </Typography>
          </Badge>
        </ButtonBase>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={latest ? translate('whatsNew') : ''} placement="top-start">
      <ButtonBase
        onClick={open}
        disabled={!latest}
        sx={{ alignSelf: 'flex-start', ml: 1, mb: 1, px: 1, py: 0.5, borderRadius: 1 }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="caption" fontSize={14} sx={{ color: 'text.secondary' }}>
            {`v${currentVersion}`}
          </Typography>
          {hasUnseen && (
            <Chip
              size="small"
              color="primary"
              variant="outlined"
              icon={dot}
              label={translate('whatsNew')}
              sx={{ height: 20, fontSize: 11, '& .MuiChip-icon': { ml: 0.75, mr: -0.25 } }}
            />
          )}
        </Stack>
      </ButtonBase>
    </Tooltip>
  );
}
